
import React from "react"
import { Popover, PopoverContent, PopoverTrigger } from "../../../../../../shadcn/ui/popover";
import { StandardTableOptionButton } from "../../../../../components/standard.table"
import { IconPencil, IconTools, IconTrash } from "@tabler/icons-react"

export interface DropdownMenuDemoProps {
    rowId: string,
    onDeleteAction: (rowId: string) => void;
    onEditAction: (rowId: string) => void;
}
export interface DropdownMenuParentProps {
    rowId: string,
    onAddChildAction: (rowId: string) => void;
    onDeleteAction: (rowId: string) => void;
    onEditAction: (rowId: string) => void;
}

function DropdownMenuItem({
    icon,
    text,
    onClick
}: {
    icon: React.ReactNode,  //recomended tabler icon size 20
    text: string,
    onClick?: () => any
}) {
    return (
        <button onClick={onClick} className=" w-full text-vstargray-800 hover:text-vstargray-100 flex rounded-md bg-maxgray-100 hover:bg-max-green-500  items-center gap-2 px-3 py-1">
            {/* icon */}
            {icon}
            {/* text */}
            <p className=" text-xs">{text}</p>
        </button>
    )
}

export function DropdownMenuParent({ rowId, onDeleteAction, onEditAction,onAddChildAction }: DropdownMenuParentProps) {

    const [openDrowdownMenu, setOpenDropdownMenu] = React.useState(false)



    return (
        <Popover open={openDrowdownMenu} onOpenChange={setOpenDropdownMenu}  >
            <PopoverTrigger asChild>
                <div onClick={(e) => {
                    e.stopPropagation();
                    setOpenDropdownMenu(!openDrowdownMenu)
                }}><StandardTableOptionButton /></div>
            </PopoverTrigger >
            <PopoverContent onOpenAutoFocus={(e) => e?.preventDefault()} className="w-[120px] bg-maxgray-100 p-1">
                <div

                    className="w-full flex flex-col gap-1">
                    <div
                        onClick={(e) => {
                            e.stopPropagation()
                            onAddChildAction(rowId)
                        }}
                    >
                        <DropdownMenuItem icon={<IconTrash size={20} />} text="Add Child" />
                    </div>
                    <div
                        className=" w-full flex"
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpenDropdownMenu(!openDrowdownMenu);
                            onEditAction(rowId);
                        }}
                    >
                        <DropdownMenuItem icon={<IconTools size={20} />} text="Edit" />
                    </div>
                    <div
                        onClick={(e) => {
                            e.stopPropagation()
                            onDeleteAction(rowId)
                        }}
                    >
                        <DropdownMenuItem icon={<IconTrash size={20} />} text="Delete" />
                    </div>

                </div>
            </PopoverContent>
        </Popover>
    )
}
export function DropdownMenuDemo({ rowId, onDeleteAction, onEditAction }: DropdownMenuDemoProps) {

    const [openDrowdownMenu, setOpenDropdownMenu] = React.useState(false)



    return (
        <Popover open={openDrowdownMenu} onOpenChange={setOpenDropdownMenu}  >
            <PopoverTrigger asChild>
                <div onClick={(e) => {
                    e.stopPropagation();
                    setOpenDropdownMenu(!openDrowdownMenu)
                }}><StandardTableOptionButton /></div>
            </PopoverTrigger >
            <PopoverContent onOpenAutoFocus={(e) => e?.preventDefault()} className="w-[120px] bg-maxgray-100 p-1">
                <div

                    className="w-full flex flex-col gap-1">
                    <div
                        className=" w-full flex"
                        onClick={(e) => {
                            e.stopPropagation();
                            setOpenDropdownMenu(!openDrowdownMenu);
                            onEditAction(rowId);
                        }}
                    >
                        <DropdownMenuItem icon={<IconTools size={20} />} text="Edit" />
                    </div>
                    <div
                        onClick={(e) => {
                            e.stopPropagation()
                            onDeleteAction(rowId)
                        }}
                    >
                        <DropdownMenuItem icon={<IconTrash size={20} />} text="Delete" />
                    </div>

                </div>
            </PopoverContent>
        </Popover>
    )
}


